import { Set } from 'immutable'
import { AsyncState, loadingAsyncState, Updater } from 'widgets-for-react'
import { AZNavigationState, initialAZNavigationState } from '../azNavigation/azNavigationState'
import { Alphabetized } from '../azNavigation/azNavigationUtils'
import { SpecialistPage } from '../cmsPage/cmsPageState'
import { getSpecialistOverviewData } from './specialistOverviewApi'

export type SpecialistOverviewState = {
  navigationState: AZNavigationState
  specialistsState: AsyncState<SpecialistPage[]>
}

export type ProcessedSpecialists = {
  departments: Set<string>
  roles: Set<string>
  groups: Alphabetized<SpecialistPage>
}

export const initialProcessedSpecialists = { departments: Set<string>(), roles: Set<string>(), groups: [] }

export const initialSpecialistOverviewState = (filter?: string, filter2?: string, query?: string): SpecialistOverviewState => ({
  navigationState: initialAZNavigationState(filter, filter2, query, ""),
  specialistsState: loadingAsyncState(() => getSpecialistOverviewData()),
})

export const specialistOverviewStateUpdaters = {
  updateNavigationState:
    (updater: Updater<AZNavigationState>) =>
    (s0: SpecialistOverviewState): SpecialistOverviewState => {
      const newState = updater(s0.navigationState)
      return {
        ...s0,
        navigationState: { ...newState, submit: false }
      }
    },
  updateSpecialistsState:
    (updater: Updater<AsyncState<SpecialistPage[]>>) =>
    (s0: SpecialistOverviewState): SpecialistOverviewState => {
      const s1 = updater(s0.specialistsState)
      return {
        ...s0,
        specialistsState: s1
      }
    }
}
